import { call, put, takeLatest } from "@redux-saga/core/effects";
import { Dashboardconstant } from "./dashboardConstant";
import { DashboardApi } from "./dashboardApi";

function* getDashboardRevenueList({ payload }) {
  try {
    yield put({ type: Dashboardconstant.DASHBOARD_REVENUE_REQUEST });

    const res = yield call(DashboardApi.getdashboardrevenue, payload);

    yield put({
      type: Dashboardconstant.DASHBOARD_REVENUE_RESPONSE,
      payload: res,
    });
  } catch (e) {
    yield put({
      type: Dashboardconstant.DASHBOARD_REVENUE_RESPONSE,
      payload: [],
    });
  }
}

function* getCoustomersList({ payload }) {
  try {
    yield put({ type: Dashboardconstant.CUSTOMERS_REQUEST });

    const res = yield call(DashboardApi.getapicustomer, payload);

    yield put({
      type: Dashboardconstant.CUSTOMERS_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("error", e);
    yield put({
      type: Dashboardconstant.CUSTOMERS_RESPONSE,
      payload: [],
    });
  }
}

function* getTimeConsumedList({ payload }) {
  try {
    yield put({ type: Dashboardconstant.TIME_CONSUMED_REQUEST });

    const res = yield call(DashboardApi.getapitimeconsumed, payload);

    yield put({
      type: Dashboardconstant.TIME_CONSUMED_RESPONSE,
      payload: res,
    });
  } catch (e) {
    yield put({
      type: Dashboardconstant.TIME_CONSUMED_RESPONSE,
      payload: [],
    });
  }
}

function* getPowerConsumedList({ payload }) {
  try {
    yield put({ type: Dashboardconstant.POWER_CONSUMED_REQUEST });

    const res = yield call(DashboardApi.getapipowerconsumed, payload);

    yield put({
      type: Dashboardconstant.POWER_CONSUMED_RESPONSE,
      payload: res,
    });
  } catch (e) {
    yield put({
      type: Dashboardconstant.POWER_CONSUMED_RESPONSE,
      payload: [],
    });
  }
}

function* getPopularTimesList({ payload }) {
  try {
    yield put({ type: Dashboardconstant.POPULAR_TIMES_REQUEST });

    const res = yield call(DashboardApi.getapipopulartime, payload);

    yield put({
      type: Dashboardconstant.POPULAR_TIMES_RESPONSE,
      payload: res,
    });
  } catch (e) {
    yield put({
      type: Dashboardconstant.POPULAR_TIMES_RESPONSE,
      payload: [],
    });
  }
}

export function* registerDashboardSaga() {
  yield takeLatest(
    Dashboardconstant.DASHBOARD_REVENUE_SAGA,
    getDashboardRevenueList
  );
  yield takeLatest(Dashboardconstant.CUSTOMERS_SAGA, getCoustomersList);
  yield takeLatest(Dashboardconstant.TIME_CONSUMED_SAGA, getTimeConsumedList);
  yield takeLatest(Dashboardconstant.POWER_CONSUMED_SAGA, getPowerConsumedList);
  yield takeLatest(Dashboardconstant.POPULAR_TIMES_SAGA, getPopularTimesList);
}
